/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Content/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import Item from './Item/index'
import React from 'react'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Content({
  children,
  viewPath = "/DesignSystem/PatientComms/PatientCommsContactMethods/Content",
  paddingLeft = 0,
  paddingRight = 0,
  paddingTop = 0,
  paddingBottom = 0,
  marginTop = 0,
  marginBottom = 0,
  marginLeft = 0,
  marginRight = 0,
  gap
  
}) {
let contactMethodsValueData = fromData.useDataValue({ viewPath,
context: 'contact_methods',
})
let dtSpaceXxs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xxs'
        })
let gapOrdtSpaceXxs = gap ?? dtSpaceXxs
  return (<React.Fragment
>
<div
  data-testid="Content.List"
  data-view-path={viewPath}
 style={{'--pl-1-Z1Yf8zk': typeof paddingLeft === 'number' ? `${paddingLeft}px` : paddingLeft,'--pr-2-Z1Yf8zk': typeof paddingRight === 'number' ? `${paddingRight}px` : paddingRight,'--pt-3-Z1Yf8zk': typeof paddingTop === 'number' ? `${paddingTop}px` : paddingTop,'--pb-4-Z1Yf8zk': typeof paddingBottom === 'number' ? `${paddingBottom}px` : paddingBottom,'--mt-5-Z1Yf8zk': typeof marginTop === 'number' ? `${marginTop}px` : marginTop,'--mb-6-Z1Yf8zk': typeof marginBottom === 'number' ? `${marginBottom}px` : marginBottom,'--ml-7-Z1Yf8zk': typeof marginLeft === 'number' ? `${marginLeft}px` : marginLeft,'--mr-8-Z1Yf8zk': typeof marginRight === 'number' ? `${marginRight}px` : marginRight,'--g-9-Z1Yf8zk': typeof gapOrdtSpaceXxs === 'number' ? `${gapOrdtSpaceXxs}px` : gapOrdtSpaceXxs}}
 className={`views-block ${styles.List}`}
>
{Array.isArray(contactMethodsValueData) && contactMethodsValueData.map((item, index, list) => 
<ListItem
        key={item?.id ?? item?._id ?? index}
        context="contact_method"
        item={item}
        index={index}
        list={list}
        hasItemKey={false}
        parentViewPath={viewPath}
        viewPath={`${viewPath}/Item(${item?.id ?? item?._id ?? index})`}
      >
<Item
 index={index} indexReverse={list.length - index} isFirst={index === 0} isLast={index === list.length - 1}
 item={item}
 viewPath={`${viewPath}/Item(${item?.id ?? item?._id ?? index})`}
/>
</ListItem>
)}
</div>
{children}
</React.Fragment>)
}

  function ListItem(props) {
    let valueItem = React.useMemo(() => ({
      index: props.index,
      indexReverse: props.list.length - props.index,
      isFirst: props.index === 0,
      isLast: props.index === props.list.length - 1,
    }), [props.index, props.list])
    
    
    
    return (
      <fromData.DataProvider
      context={props.context}
      value={props.item}
      
      
      viewPath={props.viewPath}
    >
      <fromData.DataProvider
        context={`${props.context}_item`}
        value={valueItem}
        viewPath={props.viewPath}
      >
        {props.children}
      </fromData.DataProvider>
    </fromData.DataProvider>
    )
  }